<div class="position-relative">
  <cx-spinner *ngIf="loading === LoadingEnum.Loading" class="spinner-overlay"></cx-spinner>
</div>

<ng-container *ngIf="productList?.length > 0">
  <!-- Desktop View -->
  <div class="desktop-comparison">
    <h2 class="title">{{title}} </h2>
    <div class="table-wrapper">
      <table class="comparison-table" [class.expand-cell-width]="productList.length <= 4">
        <tr *ngFor="let header of headers; let rowIndex = index">
          <th>{{header.displayName}}</th>

          <td class="table-content"
            *ngFor="let product of productList | slice:startIndex:endIndex; trackBy: trackByProductCode; let index = index;">
            <ng-container [ngSwitch]="header.key">

              <ng-container *ngSwitchCase="'name'">
                <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" 
                  [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}">
                  <span class="product-title" (click)="selectItem(product)">{{ product.name }}</span>
                </a>
              </ng-container>

              <ng-container *ngSwitchCase="'productDetails'">
                <div class="product-overview">
                  <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" 
                        [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" (click)="selectItem(product)">
                    <div class="product-image-box">
                      <cx-media *ngIf="product?.productDetails?.images;" [container]="product?.productDetails?.images"
                        format="product" [alt]="product?.productDetails?.images.altText"></cx-media>
                    </div>
                  </a>

                  <div class="purchase-actions">
                    <ng-container *ngIf="product.productDetails.purchasable; else contactForPricing;">
                      <gen-add-to-cart *ngIf="product.productDetails.purchasable"
                            [gaListName]="gaListName"
                            [gaEntrySource]="gaEntrySource"
                            [purchasable]="product.productDetails.purchasable" [productCode]="product.code"
                            [showQuantity]="false" [isSubs]="false" [isAddModal]="false" [isIcon]="false">
                      </gen-add-to-cart>
                    </ng-container>

                    <ng-template #contactForPricing>
                      <div class="position-relative contact-for-pricing" (mouseenter)="callForPricingMessage=index"
                        (mouseleave)="callForPricingMessage=null">
                        <a class="call-for-pricing link cx-action-btn-link">
                          Contact For Pricing
                          <gen-info-message [message]="callForPricingMessage === index ? tooltipMessage : ''"
                            [position]="'position-right'"></gen-info-message>
                        </a>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'price'">
                <div class="price-info" *ngIf="product.productDetails.purchasable">
                  <span class="price-msrp">MSRP: {{ product?.price?.msrp }}</span>
                  <span class="price-net">NET: {{ product?.price?.net }}</span>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div class="header-value">{{ product?.[header?.key] || 'NA'}}</div>
              </ng-container>
            </ng-container>
          </td>

          <td class="pagination-controls" *ngIf="productList.length > 4">
            <ng-container *ngIf="rowIndex === 0">
              <button *ngIf="endIndex >= productList.length" type="button" (click)="goToPreviousPage()">
                <cx-icon [type]="previousIcon"></cx-icon>
              </button>
              <button *ngIf="endIndex < productList.length" type="button" (click)="goToNextPage()">
                <cx-icon [type]="nextIcon"></cx-icon>
              </button>
            </ng-container>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!-- Mobile View -->
  <div class="mobile-comparison">
    <h2 class="title">{{title}}</h2>
    <div class="info-section" *ngFor="let product of productList trackBy: trackByProductCode; let index = index;">
      <button class="section-toggle" (click)="activeIndex = activeIndex === index ? null : index">
        <div class="product-summary">
          <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" 
                [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" (click)="selectItem(product)">
              <div class="image-container">
                <cx-media *ngIf="product?.productDetails?.images" [container]="product?.productDetails?.images"
                  format="product" [alt]="product?.productDetails?.images.altText"></cx-media>
              </div>
          </a>

          <span class="section-title" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" 
                [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" (click)="selectItem(product)">{{product.name}}</span>
        </div>
        <span class="fas" [ngClass]="activeIndex === index ? 'fa-minus' : 'fa-plus'"></span>
      </button>

      <div class="section-content" [class.active]="activeIndex === index">
        <table>
          <tr *ngFor="let header of headers; let rowIndex = index">
            <ng-container *ngIf="header.key != 'name' && header.key != 'productDetails'">
              <th>{{header.displayName}}</th>
              <ng-container [ngSwitch]="header.key">

                <ng-container *ngSwitchCase="'price'">
                  <td class="price">
                    <span class="price-msrp">MSRP: {{ product?.price?.msrp }}</span>
                    <span class="price-net">NET: {{ product?.price?.net }}</span>
                  </td>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <td>{{ product?.[header?.key] || 'NA'}}</td>
                </ng-container>
              </ng-container>
            </ng-container>
          </tr>
        </table>

        <div class="purchase-actions">
          <ng-container *ngIf="product.productDetails.purchasable; else contactForPricing;">
            <div class="add-to-cart">
              <gen-add-to-cart *ngIf="product.productDetails.purchasable"
                [gaListName]="gaListName"
                [gaEntrySource]="gaEntrySource"
                [purchasable]="product.productDetails.purchasable" [productCode]="product.code" [showQuantity]="false"
                [isSubs]="false" [isAddModal]="false" [isIcon]="false"></gen-add-to-cart>
            </div>
          </ng-container>

          <ng-template #contactForPricing>
            <div class="position-relative mobile-contact-for-pricing" (mouseenter)="callForPricingMessage=index"
              (mouseleave)="callForPricingMessage=null">
              <a class="call-for-pricing link cx-action-btn-link">
                Contact For Pricing
                <gen-info-message [message]="callForPricingMessage === index ? tooltipMessage : ''"
                  [position]="'position-right'"></gen-info-message>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>